import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import {
  Table, Row, Cell
} from '../../../components/table';

import { getProductRowColor, getProductNameColor } from '../../../../../api/PerformanceFeedback';

class MarketShareStep18 extends PureComponent {
  render() {
    const { previousShownErrors, performanceFeedbackData } = this.props;

    return (
      <BannerLayout
        section="FEEDBACK"
        subSection="MARKET SHARE"
        previousShownErrors={previousShownErrors}
        alertText="Supply Issue : Your inventory levels are high!"
        paragraph2={(
          <Fragment>
            <p><span>Customers prefer lower concentration risk:</span> They prefer to limit how many units they’ll purchase from 1 single seller. Therefore don’t expect to capture more than <b>15% of a customer segment (mobile or auto)</b>. However if there are irrational players in your competition, it’s possible to capture more than 20%.</p><br />
            <p><span>Recommendation:</span> When deciding on production, factor in the overall demand from your target customers, taking into account concentration risk limits.</p>
          </Fragment>
        )}
        visual={(
          <Table>
            <Row background="#2a4169">
              <Cell color="#ffffff">Segments</Cell>
              <Cell color="#ffffff">Available Inventory</Cell>
              <Cell color="#ffffff">Customer Demand</Cell>
              <Cell color="#ffffff">Inventory %<br /> of Demand</Cell>
            </Row>
            {performanceFeedbackData.map((item, index) => {
              const parsedItemMessage = JSON.parse(item.message);

              const availableForSale = parsedItemMessage.available_for_sale;
              const demand = parsedItemMessage.demand;
              const segment = parsedItemMessage.segment;
              const inventoryPercentageOfDemand = availableForSale / demand;
              return (
                <Row background={getProductRowColor(index)} key={index}>
                  <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{segment}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{availableForSale.toLocaleString()}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{demand.toLocaleString()}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{(inventoryPercentageOfDemand * 100).toFixed(2)}%</Cell>
                </Row>
              )
            })}
          </Table>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }

}

export default MarketShareStep18;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step18.js